import React from "react";
import classNames from "classnames";
import "./Checkbox.scss";

import { v1 as uuidv1 } from "uuid";
import { withDefaults } from "../../utils/withDefaults";

export interface CheckboxProps {
  className?: string;
  isChecked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /** Used as both the input id and name, so the label can point at it. */
  uniqueId?: string;
  label?: string;
  reference?: React.Ref<HTMLInputElement>;
}

export default function Checkbox(incomingProps: CheckboxProps) {
  const props = withDefaults(incomingProps, checkboxDefaultProps);

  return (
    <div className={classNames("checkbox-row", props.className)}>
      <input
        type="checkbox"
        id={props.uniqueId}
        ref={props.reference}
        name={props.uniqueId}
        checked={props.isChecked}
        onChange={props.onChange}
      />
      <label htmlFor={props.uniqueId}>{props.label}</label>
    </div>
  );
}

const checkboxDefaultProps = {
  className: "",
  isChecked: false,
  onChange: () => {},
  uniqueId: uuidv1(),
  label: ""
};
